import React, { useEffect, useState } from "react";
import styles from "./Navbar.module.css";
import logo from "../../asset/navbar/workingdom-logo.png";
import logoBlack from "../../asset/navbar/workingdom-black.webp";
// import hamburgerIcon from "../../asset/navbar/hamburger.png";
import closeIcon from "../../asset/navbar/close.png";
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { appendUTMParamsToUrlEnhanced } from "../../utils/utm-utils";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import FixedButton from "../FixedButton/FixedButton";
import FixedButtons from "../FixedButtons/FixedButtons";
import { trackCall, zohoUrl, zohoUrlClicked } from "../../utils/utils";
import FixedWeb from "../FixedWeb/FixedWeb";
import { useContactDetails } from "../../contexts/contact-context";

const Navbar = () => {
  const [bg, setBg] = useState(false);
  const { slug, category, place } = useParams();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  //console.log(location, "navbar", slug);
  //console.log(location, "lop");
  const handleClick = () => {
    if (!slug) {
      //navigate("/locations/delhi");
      window.open(zohoUrl, "_blank");
    } else {
      // Preserve UTM parameters in URL when navigating to free-tour
      const utmParams = Object.fromEntries(searchParams);
      const urlWithUTM = appendUTMParamsToUrlEnhanced("/free-tour");
      navigate(urlWithUTM, {
        state: { 
          ...location.state, 
          propertyName: slug,
          utmParams: utmParams
        },
      });
    }
  };
  const [open, setOpen] = useState(true);
  const toggler = () => {
    setOpen((p) => !p);
  };

  useEffect(() => {
    if (!open) {
      document.body.style.position = "fixed";
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.position = "relative";
      document.body.style.overflowY = "unset";
    }
  }, [open]);

  const { pathname } = useLocation();

  // useEffect(() => {
  //   if (
  //     pathname === "/covid-response" ||
  //     pathname === "/" ||
  //     pathname === "/contact-us" ||
  //     pathname === "/solutions"
  //   ) {
  //     setBg(true);
  //   }
  // }, []);

  const handleScroll = () => {
    const headerDistance = window.scrollY;

    if (headerDistance === 0) {
      if (
        // pathname === "/" ||
        // pathname === "/covid-response" ||
        // pathname === "/contact-us" ||
        // pathname === "/solutions"
        pathname === "/hh"
      )
        setBg(true);
    } else {
      setBg(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { phone, displayNumber } = useContactDetails();

  return (
    <>
      <header className={`${!bg ? styles.container : styles.newHead}`}>
        <div className={styles.header}>
          <div className={styles.left}>
            <div className={styles.logo}>
                              <Link to={appendUTMParamsToUrlEnhanced("/")}>
                <img src={!bg ? logo : logoBlack} alt="workingdom-logo" />
              </Link>
            </div>
            <nav className={`${!bg ? styles.navItems : styles.newNavItems}`}>
              <ul>
                <li>
                  <Link to={appendUTMParamsToUrlEnhanced("/locations")}>
                    Locations
                  </Link>
                </li>
                <li>
                  <Link to={appendUTMParamsToUrlEnhanced("/solutions")}>
                    Solutions
                  </Link>
                </li>
                {/* <li>
                  <Link to="/partnerships">Partnerships</Link>
                </li> */}
                <li>
                  <Link to={appendUTMParamsToUrlEnhanced("/covid-response")}>
                    Covid Response
                  </Link>
                </li>
                {/* <li >
                  <a href={zohoUrl} target="_blank" rel="noreferrer">
                    Book by the day
                  </a>
                </li> */}
              </ul>
            </nav>
          </div>
          {/* <div className={styles.btn}>
          <button className={styles.button}>
            <span>
              <b>Book a free tour</b>
            </span>
          </button>
        </div> */}
          <div className={styles.right}>
            {/* <a href="tel:+918287999888">
            <button className={styles.btnPhone}>
              <img src={webPhone} alt="phone" />
              <div>
                <h5>Dial +91 828 799 9888</h5>
                <h6>Our helpline number</h6>
              </div>
            </button>
          </a> */}
            <a
              href={`tel:${phone}`}
              className={`${!bg ? styles.btnPhone : styles.btnNew}`}
              onClick={() => trackCall(pathname)}
            >
              <div className={styles.h5}>{displayNumber}</div>
            </a>
            <button onClick={handleClick} className={styles.btn}>
              {slug ? "Book a free tour" : "Book now"}
            </button>
          </div>
          <div className={styles.hamburger} onClick={toggler}>
            {!open ? (
              <>
                <img src={closeIcon} alt="close" />
                {/* <div className={styles.crossLineBlack1}>
                  <div className={styles.crossLineBlack2}></div>
                </div> */}
              </>
            ) : (
              <>
                <div
                  className={`${
                    !bg ? styles.hamburgerLine : styles.hamburgerLineBlack
                  }`}
                ></div>
                <div
                  className={`${
                    !bg ? styles.hamburgerLine : styles.hamburgerLineBlack
                  }`}
                ></div>
                <div
                  className={`${
                    !bg ? styles.hamburgerLine : styles.hamburgerLineBlack
                  }`}
                ></div>
              </>
            )}
          </div>
          {!open && (
            <div className={styles.fullNavbar}>
              <div className={styles.navWrapper}>
                <nav className={styles.navItemsMb}>
                  <ul>
                    <li>
                      <Link to={appendUTMParamsToUrlEnhanced("/")} onClick={toggler}>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={toggler} to={appendUTMParamsToUrlEnhanced("/locations")}>
                        Locations
                      </Link>
                    </li>
                    <li>
                      <Link onClick={toggler} to={appendUTMParamsToUrlEnhanced("/solutions")}>
                        Solutions
                      </Link>
                    </li>
                    {/* <li>
                      <Link onClick={toggler} to="/partnerships">
                        Partnerships
                      </Link>
                    </li> */}
                    <li>
                      <Link onClick={toggler} to={appendUTMParamsToUrlEnhanced("/covid-response")}>
                        Covid Response
                      </Link>
                    </li>

                    {/* <li>
                      <a
                        href={zohoUrl}
                        target="_blank"
                        rel="noreferrer"
                        onClick={toggler}
                      >
                        Book by the day
                      </a>
                    </li> */}
                    {/* <li>
                      <Link onClick={toggler} to="/startup-credits">
                        Startup Credits
                      </Link>
                    </li> */}
                  </ul>
                </nav>
                <div className={styles.btnWrapper}>
                  <h5>To know more about our products, please call us @</h5>
                  <h6>
                    <a
                      href={`tel:${phone}`}
                      onClick={() => trackCall(pathname)}
                    >
                      {displayNumber}
                    </a>
                  </h6>
                  <div className={styles.line}>
                    <hr />
                    OR <hr />
                  </div>
                  <button onClick={handleClick} className={styles.btnMb}>
                    {slug ? "Book a free tour" : "Book now"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </header>
      {width < 500 && <FixedButton bg={!open ? "#fff" : "#030834"} />}
      {width < 500 && !slug && open && !category && !place && <FixedButtons />}
      {width > 500 && <FixedWeb />}
    </>
  );
};

export default Navbar;
